import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

/** 申诉代码加载时保留提示、三行现有列表和分页操作区，不挂载勾选或提交逻辑 */
export function AppealSkeleton() {
  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-9" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
      <Card className="@container/card">
        <CardContent className="space-y-4">
          {/** 申诉提示区，窄卡片为提示换行预留高度 */}
          <div className="flex items-start gap-2 rounded-md bg-blue-50 p-3">
            <Skeleton className="mt-0.5 h-4 w-4 shrink-0 bg-blue-200/70" />
            <div className="flex-1">
              <Skeleton className="h-5 w-full bg-blue-200/70" />
              <Skeleton className="h-5 w-1/3 bg-blue-200/70 @[900px]/card:hidden" />
            </div>
          </div>

          {/** 原页面使用普通 Table：七列、40px 表头和三条含 64px 封面的记录 */}
          <div className="rounded-md border overflow-hidden">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[50px]">
                    <Skeleton className="h-4 w-4" />
                  </TableHead>
                  {Array.from({ length: 6 }, (_, index) => (
                    <TableHead key={index}>
                      <Skeleton className="h-4 w-16" />
                    </TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {Array.from({ length: 3 }, (_, index) => (
                  <TableRow key={index}>
                    <TableCell><Skeleton className="h-4 w-4" /></TableCell>
                    <TableCell><Skeleton className="h-16 w-16 rounded" /></TableCell>
                    <TableCell><Skeleton className="h-5 w-44" /></TableCell>
                    <TableCell><Skeleton className="h-5 w-56" /></TableCell>
                    <TableCell><Skeleton className="h-5 w-60" /></TableCell>
                    <TableCell><Skeleton className="h-5 w-16" /></TableCell>
                    <TableCell><Skeleton className="h-5 w-16" /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>

          {/** 总数、每页条数及上一页／下一页 */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-5 w-24" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-9 w-20" />
              <Skeleton className="h-5 w-10" />
              <Skeleton className="h-8 w-10" />
              <Skeleton className="h-5 w-20" />
              <Skeleton className="h-8 w-10" />
            </div>
          </div>
          {/** 选择数量、取消选择和继续操作 */}
          <div className="flex items-center justify-between pt-4 border-t">
            <div className="flex items-center gap-4">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-8 w-20" />
            </div>
            <div className="flex items-center gap-4">
              <Skeleton className="h-9 w-16" />
              <Skeleton className="h-9 w-16" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
